export default __webpack_public_path__ + "static/Q6_3_MediumDog-b8abdceadebfc3a97c14b4734e5afe42.svg";